import { api } from '@teacher/api';

export default {
  refreshUser({ commit }) {
    // 用户信息
    return api.businessLogin().then(async (res) => {
      // 设置权限
      commit('user', res.data.userInfo);
    });
  },
};
